import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["starttijd", "tijdsduur", "eindtijd", "eindtijdHidden"]

  connect() {
    console.log('activiteit_tijdstip connected');
  }

  maskTime(event) {
    const input = event.target
    let value = input.value

    // Remove everything except digits
    let digits = value.replace(/\D/g, '')

    // If user is deleting and we have exactly 2 digits with no colon in input,
    // they're trying to delete past the colon, so remove a digit
    if (event.inputType === 'deleteContentBackward' && digits.length === 2 && !value.includes(':')) {
      digits = digits.slice(0, 1)
    }

    // Limit to 4 digits
    digits = digits.slice(0, 4)

    // Clamp first digit of hours (0-2)
    if (digits.length >= 1) {
      let h1 = parseInt(digits[0], 10)
      if (h1 > 2) digits = '2' + digits.slice(1)
    }

    // Clamp second digit of hours based on first
    if (digits.length >= 2) {
      let h1 = parseInt(digits[0], 10)
      let h2 = parseInt(digits[1], 10)
      if (h1 === 2 && h2 > 3) {
        digits = digits[0] + '3' + digits.slice(2)
      }
    }

    // Clamp first digit of minutes (0-5)
    if (digits.length >= 3) {
      let m1 = parseInt(digits[2], 10)
      if (m1 > 5) digits = digits.slice(0, 2) + '5' + digits.slice(3)
    }

    // Format with colon - show colon immediately after 2 digits
    if (digits.length >= 2) {
      input.value = digits.slice(0, 2) + ':' + digits.slice(2)
    } else {
      input.value = digits
    }
  }

  maskDigits(event) {
    const input = event.target
    input.value = input.value.replace(/\D/g, '')
  }

  pas_eindtijd_aan(event) {
    event.preventDefault()

    const tijdsduur = Math.round(parseFloat(this.tijdsduurTarget.value) || 0)
    const starttijd = this.starttijdTarget.value.trim()

    // Validate format before calculating
    if (!/^[0-2][0-9]:[0-5][0-9]$/.test(starttijd)) {
      return
    }

    if (tijdsduur > 0 && starttijd.length === 5) {
      const [hours, minutes] = starttijd.split(":").map(s => parseInt(s, 10))

      let eindtijd0 = hours + Math.floor(tijdsduur / 60)
      let eindtijd1 = minutes + (tijdsduur % 60)

      if (eindtijd1 > 59) {
        eindtijd0 += Math.floor(eindtijd1 / 60)
        eindtijd1 = eindtijd1 % 60
      }

      const et = `${eindtijd0.toString().padStart(2, '0')}:${eindtijd1.toString().padStart(2, '0')}`

      this.eindtijdTarget.value = et
      this.eindtijdHiddenTarget.value = et

      console.log(et)
    }
  }
}
